module.exports = __webpack_public_path__ + "static/media/lc_jan.24c99dd4.png";